/* import __COLOCATED_TEMPLATE__ from './stripe-payment-element.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './stripe-payment-element.module.scss';

export default class SiteBillingPaymentModalStripePaymentElement extends Component {
  @service stripePaymentElementService;
  @service session;
  @service currentPractice;

  styles = styles;

  willDestroy() {
    super.willDestroy(...arguments);

    this.stripePaymentElementService.destroyElement();
  }

  get isPaymentElementLoaded() {
    return this.stripePaymentElementService.isLoaded;
  }

  @action
  async attachPaymentElement(_element) {
    if (!this.args.stripeElement) {
      return;
    }

    let options = {
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
      disableLink: this.currentPractice.get('featureStripeAchPayments'),
    };

    if (this.currentPractice.get('featureStripeLinkPassthroughMode')) {
      let client = this.session.currentClientAccess?.client;

      if (client) {
        options.email = client.email;
        options.phone = client.phoneNumber;
      }
    }

    let paymentElement = this.stripePaymentElementService.getOrCreateElement(
      this.args.stripeElement,
      options
    );
    paymentElement.mount('#payment-element');
  }
}
